import { ErrorMessage, Field, Form, FormikProvider, useFormik } from "formik";
import { useEffect, useRef, useState } from "react";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import { config } from "../../CommonUtils/CommonURLS";
import * as bie from "react-bootstrap";
import * as Yup from 'yup';
import { ERROR_MSG } from "../../CommonUtils/contextVariables";
import moment from "moment";
import { failureAlert, successAlertRefresh } from "../../CommonUtils/SweetAlerts";
import allowNumbersOnly, { handlePaste } from "../../CommonUtils/CommonValidations";
import CommonFormHeading from "../../CommonUtils/CommonFormHeading";

export default function AffiliationCollegeCourseIntakeDetails() {

    const hasFetchedData = useRef(false)
    const [sowCourseIntakedata, setCourseIntakeData] = useState([])
    const [showTotCourseIntakedata, setTotCourseIntakeData] = useState([])
    const dispatch = useDispatch();


    function GetClgCousreIntakeDetails() {
        let courseUrl = config.url.API_URL + "getCollegeCourseIntake";
        let courseTotalUrl = config.url.API_URL + "getintakeTotDetails";

        CommonAxiosGet(courseUrl, dispatch).then((resCourse) => {
            if (resCourse?.data?.scode === "01") {
                setCourseIntakeData(resCourse?.data?.getCollegeCourseIntake)
                clgCourseIntakeformik?.setFieldValue("rowCount", resCourse?.data?.data_count)
                resCourse?.data?.getCollegeCourseIntake?.forEach((data, i) => {
                })
            }
            else {
                setCourseIntakeData([])
                clgCourseIntakeformik?.setFieldValue("rowCount", 0)
            }
        })
        CommonAxiosGet(courseTotalUrl, dispatch).then((restotCourse) => {
            if (restotCourse?.data?.scode === "01") {
                setTotCourseIntakeData(restotCourse?.data?.getintakeTotDetails[0])


            }
            else {
                setTotCourseIntakeData([])
            }
        })
    }

    const ClgcourseIntakeValidation = Yup.object().shape({
        clgCourseIntake: Yup.array().of(
            Yup.object().shape({
                // courseStartDate: Yup.string().required(ERROR_MSG).nullable(),
                courseStartDate: Yup.string()
                    .required("Course start date is required")
                    .test("is-valid-date", "Invalid date", (value) =>
                        moment(value, "YYYY-MM-DD", true).isValid()
                    )
                    .nullable(),

                sanctionedIntakeCompetentAuth24: Yup.string().required(ERROR_MSG).nullable(),
                noOfSectionsCompetAuth24: Yup.string().required(ERROR_MSG).nullable(),
                lateral24: Yup.string().required(ERROR_MSG).nullable(),
                ews24: Yup.string().required(ERROR_MSG).nullable(),
                pioIntake24: Yup.string().required(ERROR_MSG).nullable(),
                approved24: Yup.string().required(ERROR_MSG).nullable(),
                admitted24: Yup.string().required(ERROR_MSG).nullable(),
                sanctionedIntakeCompetentAuth23: Yup.string().required(ERROR_MSG).nullable(),
                noOfSectionsCompetAuth23: Yup.string().required(ERROR_MSG).nullable(),
                lateral23: Yup.string().required(ERROR_MSG).nullable(),
                ews23: Yup.string().required(ERROR_MSG).nullable(),
                pioIntake23: Yup.string().required(ERROR_MSG).nullable(),
                admitted23: Yup.string().required(ERROR_MSG).nullable(),
                sanctionedIntakeCompetentAuth22: Yup.string().required(ERROR_MSG).nullable(),
                noOfSectionsCompetAuth22: Yup.string().required(ERROR_MSG).nullable(),
                lateral22: Yup.string().required(ERROR_MSG).nullable(),
                ews22: Yup.string().required(ERROR_MSG).nullable(),
                pioIntake22: Yup.string().required(ERROR_MSG).nullable(),
                admitted22: Yup.string().required(ERROR_MSG).nullable(),
                approved22: Yup.string().required(ERROR_MSG).nullable(),
                sanctionedIntakeCompetentAuth21: Yup.string().required(ERROR_MSG).nullable(),
                noOfSectionsCompetAuth21: Yup.string().required(ERROR_MSG).nullable(),
                lateral21: Yup.string().required(ERROR_MSG).nullable(),
                approved21: Yup.string().required(ERROR_MSG).nullable(),
                ews21: Yup.string().required(ERROR_MSG).nullable(),
                pioIntake21: Yup.string().required(ERROR_MSG).nullable(),
                admitted21: Yup.string().required(ERROR_MSG).nullable(),
            })
        ),
    });
    const clgCourseIntakeformik = useFormik({
        initialValues: {
            rowCount: "",
            clgCourseIntake: []
        },
        enableReinitialize: true,
        validationSchema: ClgcourseIntakeValidation,
        onSubmit: (val) => {
            Swal.fire({
                title: "Are you sure want to submit the data?",
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: "Submit",
                cancelButtonText: "Cancel",
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    let saveUrl = config.url.API_URL + `saveCollegeCourseIntake `
                    CommonAxiosPost(saveUrl, val?.clgCourseIntake, dispatch).then((resAtsave) => {
                        if (resAtsave?.data?.scode === '01') {
                            successAlertRefresh(resAtsave?.data?.sdesc);
                        }
                        else {
                            failureAlert("Failed to submit")
                        }
                    })
                }
            });
        }
    })
    useEffect(() => {
        if (sowCourseIntakedata) {
            const clgValues = sowCourseIntakedata?.map(data => ({
                regSelf: data?.reg_self_code,
                mediumCode: data?.medium_code,
                courseAfflType: data?.course_affl_type,
                courseId: data?.course_id,
                courseStartDate: data?.course_start_date
                    ? moment(data.course_start_date, "DD-MM-YYYY").format("YYYY-MM-DD")
                    : "",
                sanctionedIntakeCompetentAuth24: data?.sanctioned_intake_competent_auth_24,
                noOfSectionsCompetAuth24: data?.no_of_sections_compet_auth_24,
                approved24: data?.approved_24,
                lateral24: data?.lateral_24,
                ews24: data?.ews_24,
                pioIntake24: data?.pio_intake_24,
                cummulativeIntake24: data?.cummulative_intake_24,
                admitted24: data?.addmited_24,
                sanctionedIntakeCompetentAuth23: data?.sanctioned_intake_competent_auth_23,

                noOfSectionsCompetAuth23: data?.no_of_sections_compet_auth_23,
                approved23: data?.approved_23,
                lateral23: data?.lateral_23,
                ews23: data?.ews_23,
                pioIntake23: data?.pio_intake_23,
                cummulativeIntake23: data?.cummulative_intake_23,
                admitted23: data?.addmited_23,

                sanctionedIntakeCompetentAuth22: data?.sanctioned_intake_competent_auth_22,
                noOfSectionsCompetAuth22: data?.no_of_sections_compet_auth_22,
                approved22: data?.approved_22,
                lateral22: data?.lateral_22,
                ews22: data?.ews_22,
                pioIntake22: data?.pio_intake_22,
                cummulativeIntake22: data?.cummulative_intake_22,
                admitted22: data?.addmited_22,

                sanctionedIntakeCompetentAuth21: data?.sanctioned_intake_competent_auth_21,
                noOfSectionsCompetAuth21: data?.no_of_sections_compet_auth_21,
                approved21: data?.approved_21,
                lateral21: data?.lateral_21,
                ews21: data?.ews_21,
                pioIntake21: data?.pio_intake_21,
                cummulativeIntake21: data?.cummulative_intake_21,
                admitted21: data?.addmited_21
            }));
            clgCourseIntakeformik.setValues({ ...clgCourseIntakeformik?.values, clgCourseIntake: clgValues });
        }
    }, [sowCourseIntakedata]);

    const calculateCumulativeIntake = (index, year) => {
        const approved = parseInt(clgCourseIntakeformik.values.clgCourseIntake[index]?.[`approved${year}`] || 0, 10);
        const lateral = parseInt(clgCourseIntakeformik.values.clgCourseIntake[index]?.[`lateral${year}`] || 0, 10);
        const ews = parseInt(clgCourseIntakeformik.values.clgCourseIntake[index]?.[`ews${year}`] || 0, 10);
        const pioIntake = parseInt(clgCourseIntakeformik.values.clgCourseIntake[index]?.[`pioIntake${year}`] || 0, 10);
        const cumulative = lateral + ews + pioIntake + approved;
        const currentCumulative = clgCourseIntakeformik.values.clgCourseIntake[index]?.[`cummulativeIntake${year}`];
        // if (cumulative !== currentCumulative) {
        clgCourseIntakeformik.setFieldValue(`clgCourseIntake[${index}].cummulativeIntake${year}`, cumulative || 0);
        // }
    };
    const calculateTotals = () => {
        const totals = {

            tot_sanctioned_intake_competent_auth_24: 0,
            tot_no_of_sections_compet_auth_24: 0,
            tot_approved_24: 0,
            tot_lateral_24: 0,
            tot_ews_24: 0,
            tot_pio_intake_24: 0,
            tot_cummulative_intake_24: 0,
            tot_addmited_24: 0,

            tot_sanctioned_intake_competent_auth_23: 0,
            tot_no_of_sections_compet_auth_23: 0,
            tot_approved_23: 0,
            tot_lateral_23: 0,
            tot_ews_23: 0,
            tot_pio_intake_23: 0,
            tot_cummulative_intake_23: 0,
            tot_addmited_23: 0,

            tot_sanctioned_intake_competent_auth_22: 0,
            tot_no_of_sections_compet_auth_22: 0,
            tot_approved_22: 0,
            tot_lateral_22: 0,
            tot_ews_22: 0,
            tot_pio_intake_22: 0,
            tot_cummulative_intake_22: 0,
            tot_addmited_22: 0,

            tot_sanctioned_intake_competent_auth_21: 0,
            tot_no_of_sections_compet_auth_21: 0,
            tot_approved_21: 0,
            tot_lateral_21: 0,
            tot_ews_21: 0,
            tot_pio_intake_21: 0,
            tot_cummulative_intake_21: 0,
            tot_addmited_21: 0,


        };

        clgCourseIntakeformik?.values?.clgCourseIntake?.forEach((data, index) => {
            // Sum values for each year

            totals.tot_sanctioned_intake_competent_auth_24 += parseInt(data.sanctionedIntakeCompetentAuth24 || 0);
            totals.tot_no_of_sections_compet_auth_24 += parseInt(data.noOfSectionsCompetAuth24 || 0);
            totals.tot_approved_24 += parseInt(data.approved24 || 0);
            totals.tot_lateral_24 += parseInt(data.lateral24 || 0);
            totals.tot_ews_24 += parseInt(data.ews24 || 0);
            totals.tot_pio_intake_24 += parseInt(data.pioIntake24 || 0);
            totals.tot_cummulative_intake_24 += parseInt(data.cummulativeIntake24 || 0);
            totals.tot_addmited_24 += parseInt(data.admitted24 || 0);

            totals.tot_sanctioned_intake_competent_auth_23 += parseInt(data.sanctionedIntakeCompetentAuth23 || 0);
            totals.tot_no_of_sections_compet_auth_23 += parseInt(data.noOfSectionsCompetAuth23 || 0);
            totals.tot_approved_23 += parseInt(data.approved23 || 0);
            totals.tot_lateral_23 += parseInt(data.lateral23 || 0);
            totals.tot_ews_23 += parseInt(data.ews23 || 0);
            totals.tot_pio_intake_23 += parseInt(data.pioIntake23 || 0);
            totals.tot_cummulative_intake_23 += parseInt(data.cummulativeIntake23 || 0);
            totals.tot_addmited_23 += parseInt(data.admitted23 || 0);

            totals.tot_sanctioned_intake_competent_auth_22 += parseInt(data.sanctionedIntakeCompetentAuth22 || 0);
            totals.tot_no_of_sections_compet_auth_22 += parseInt(data.noOfSectionsCompetAuth22 || 0);
            totals.tot_approved_22 += parseInt(data.approved22 || 0);
            totals.tot_lateral_22 += parseInt(data.lateral22 || 0);
            totals.tot_ews_22 += parseInt(data.ews22 || 0);
            totals.tot_pio_intake_22 += parseInt(data.pioIntake22 || 0);
            totals.tot_cummulative_intake_22 += parseInt(data.cummulativeIntake22 || 0);
            totals.tot_addmited_22 += parseInt(data.admitted22 || 0);

            totals.tot_sanctioned_intake_competent_auth_21 += parseInt(data.sanctionedIntakeCompetentAuth21 || 0);
            totals.tot_no_of_sections_compet_auth_21 += parseInt(data.noOfSectionsCompetAuth21 || 0);
            totals.tot_approved_21 += parseInt(data.approved21 || 0);
            totals.tot_lateral_21 += parseInt(data.lateral21 || 0);
            totals.tot_ews_21 += parseInt(data.ews21 || 0);
            totals.tot_pio_intake_21 += parseInt(data.pioIntake21 || 0);
            totals.tot_cummulative_intake_21 += parseInt(data.cummulativeIntake21 || 0);
            totals.tot_addmited_21 += parseInt(data.admitted21 || 0);


        });


        Object.keys(totals).forEach((key) => {
            const currentValue = clgCourseIntakeformik.values[key];
            // if (totals[key] !== currentValue) {
            clgCourseIntakeformik.setFieldValue(key, totals[key]);
            // }
        });

    };

    useEffect(() => {
        if (!hasFetchedData.current) {
            GetClgCousreIntakeDetails()
            hasFetchedData.current = true
        }
    }, [])


    const validateFieldPair = (index, field1, field2, comparisonFn, formik) => {
        const value1 = parseInt(formik?.values?.clgCourseIntake?.[index]?.[field1] || '0', 10);
        const value2 = parseInt(formik?.values?.clgCourseIntake?.[index]?.[field2] || '0', 10);

        if (comparisonFn(value1, value2)) {
            Swal.fire({
                title: 'Error',
                text: `Admitted value cannot be greater than Cumulative Intake by university value.`,
                icon: 'error',
                confirmButtonText: 'OK',
                backdrop: false
            }).then(() => {
                formik.setFieldValue(`clgCourseIntake[${index}].${field1}`, '');
            });
        }
    };
    const getDisplayValue = (formikValue, fallbackValue) => {
        return formikValue !== '' && formikValue !== undefined && formikValue !== null
            ? formikValue
            : fallbackValue || '';
    };

    return (
        <>
            <bie.Container fluid className="px-1" >
                <CommonFormHeading heading="Courses with Intake Details" />

                {/* <bie.Row>
                    <bie.Col xs={12} sm={12} md={12} lg={11} xl={11} xxl={11} className="">
                        <div className="inner-herbpage-service-title1">
                            <h1>{`Courses with Intake Details`}</h1>
                        </div>
                    </bie.Col>
                    <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1} className='mb-2'>
                        <button className="breadcrumb-item"><a href="/dashboard" className='affl-dash'><FaHome size={30} /></a></button>
                    </bie.Col>
                </bie.Row> */}
                <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                    <FormikProvider value={clgCourseIntakeformik}>
                        <Form onChange={clgCourseIntakeformik.handleChange} onSubmit={clgCourseIntakeformik.handleSubmit} className="form_adjust" >
                            {sowCourseIntakedata.length > 0 ? (<>
                                <center>
                                    <br />
                                    <font style={{ fontFamily: "sans-serif", fontSize: "14px", color: "red", fontweight: "bold" }}>
                                        Note: ** Please enter 0 if the field is not applicable **</font></center>

                            </>) : (<center className='text-danger h5 pt-5'>***** No Data Found *****</center>)}
                            {sowCourseIntakedata?.length > 0 ? <>

                                <div className="table-responsive">
                                    <table className="sticky-table affl-table table-bordered table ">
                                        <thead className="sticky-header">
                                            <tr>
                                                <th rowSpan={3} className="sticky-header">Slno</th>
                                                <th rowSpan={3} className="sticky-header">Course/Programme</th>
                                                <th rowSpan={3} className="sticky-header">Branch/Combination</th>
                                                <th rowSpan={3} className="sticky-header">Year of<br />Starting Course</th>
                                                <th colSpan={32} className="sticky-header">Details of Intake year wise</th>
                                            </tr>
                                            <tr>
                                                <th colSpan={8} className="sticky-header" >2024-25</th>
                                                <th colSpan={8} className="sticky-header">2023-24</th>
                                                <th colSpan={8} className="sticky-header">2022-23</th>
                                                <th colSpan={8} className="sticky-header">2021-22</th>

                                            </tr>
                                            <tr>
                                                <th rowSpan={1} className="sticky-header">Sanctioned by Competent Authority (AICTE/APSCHE/BCI/PCI)</th>
                                                <th colSpan={1} className="sticky-header">Approved Number of Sections</th>
                                                <th colSpan={1} className="sticky-header">Approved Intake by University</th>
                                                <th colSpan={1} className="sticky-header">Lateral Entries</th>
                                                <th colSpan={1} className="sticky-header">EWS</th>
                                                <th colSpan={1} className="sticky-header">NRI/PIO/Foreign</th>
                                                <th colSpan={1} className="sticky-header">Cumulative Intake</th>
                                                <th colSpan={1} className="sticky-header" >Admitted</th>

                                                <th rowSpan={1} className="sticky-header">Sanctioned by Competent Authority (AICTE/APSCHE/BCI/PCI)</th>
                                                <th colSpan={1} className="sticky-header">Approved Number of Sections</th>
                                                <th colSpan={1} className="sticky-header">Approved Intake by University</th>
                                                <th colSpan={1} className="sticky-header" >Lateral Entries</th>
                                                <th colSpan={1} className="sticky-header">EWS</th>
                                                <th colSpan={1} className="sticky-header" >NRI/PIO/Foreign</th>
                                                <th colSpan={1} className="sticky-header">Cumulative Intake</th>
                                                <th colSpan={1} className="sticky-header" >Admitted</th>

                                                <th rowSpan={1} className="sticky-header">Sanctioned by Competent Authority (AICTE/APSCHE/BCI/PCI)</th>
                                                <th colSpan={1} className="sticky-header">Approved Number of Sections</th>
                                                <th colSpan={1} className="sticky-header" >Approved Intake by University</th>
                                                <th colSpan={1} className="sticky-header" >Lateral Entries</th>
                                                <th colSpan={1} className="sticky-header">EWS</th>
                                                <th colSpan={1} className="sticky-header">NRI/PIO/Foreign</th>
                                                <th colSpan={1} className="sticky-header">Cumulative Intake</th>
                                                <th colSpan={1} className="sticky-header" >Admitted</th>

                                                <th rowSpan={1} className="sticky-header">Sanctioned by Competent Authority (AICTE/APSCHE/BCI/PCI)</th>
                                                <th colSpan={1} className="sticky-header">Approved Number of Sections</th>
                                                <th colSpan={1} className="sticky-header">Approved Intake by University</th>
                                                <th colSpan={1} className="sticky-header">Lateral Entries</th>
                                                <th colSpan={1} className="sticky-header">EWS</th>
                                                <th colSpan={1} className="sticky-header">NRI/PIO/Foreign</th>
                                                <th colSpan={1} className="sticky-header" >Cumulative Intake</th>
                                                <th colSpan={1} className="sticky-header" >Admitted</th>
                                            </tr>

                                        </thead>
                                        <tbody style={{ textAlign: "center" }}>
                                            {sowCourseIntakedata && sowCourseIntakedata?.map((data, index) => (
                                                <tr>
                                                    <td >{index + 1}</td>
                                                    <td style={{ textAlign: "left" }}>{`${data.course_cat_name}(${data.medium})/${data.reg_self}/${data.course_affl_type}`}
                                                        <Field type="hidden" name={`clgCourseIntake[${index}].regSelf`} />
                                                        <Field type="hidden" name={`clgCourseIntake[${index}].mediumCode`} />
                                                        <Field type="hidden" name={`clgCourseIntake[${index}].acYear`} />
                                                        <Field type="hidden" name={`clgCourseIntake[${index}].collegeCode`} />
                                                        <Field type="hidden" name={`clgCourseIntake[${index}].courseAfflType`} />
                                                    </td>
                                                    <td style={{ textAlign: "left" }}>{data.course_name}
                                                        <Field type="hidden" name={`clgCourseIntake[${index}].courseId`} />
                                                    </td>
                                                    <td>  <Field type="date" className="form-control" name={`clgCourseIntake[${index}].courseStartDate`}
                                                        onKeyDown={(e) => { e.preventDefault() }} max={new Date().toISOString().split('T')[0]} min={"1970-01-01"} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].courseStartDate`} className='text-error' component='div' />

                                                    </td>
                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].sanctionedIntakeCompetentAuth24`}
                                                        maxLength="5" onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)} onKeyUp={() => calculateTotals()} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].sanctionedIntakeCompetentAuth24`} className='text-error' component='div' />

                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].noOfSectionsCompetAuth24`}
                                                        maxLength="3" onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)} onKeyUp={() => calculateTotals()} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].noOfSectionsCompetAuth24`} className='text-error' component='div' />

                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].approved24`}
                                                        maxLength="5" onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)}
                                                        onKeyUp={() => { calculateCumulativeIntake(index, '24'); calculateTotals() }} disabled="true" />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].approved24`} className='text-error' component='div' />



                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].lateral24`}
                                                        maxLength="5" onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)}
                                                        onKeyUp={() => { calculateCumulativeIntake(index, '24'); calculateTotals() }} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].lateral24`} className='text-error' component='div' />

                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].ews24`} style={{ width: "5rem" }}
                                                        maxLength="5" onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)}
                                                        onKeyUp={() => { calculateCumulativeIntake(index, '24'); calculateTotals() }} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].ews24`} className='text-error' component='div' />


                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].pioIntake24`}
                                                        maxLength="5" onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)}
                                                        onKeyUp={() => { calculateCumulativeIntake(index, '24'); calculateTotals() }} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].pioIntake24`} className='text-error' component='div' />

                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].cummulativeIntake24`}
                                                        maxLength="5" disabled="true" onKeyUp={() => calculateTotals()} /></td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].admitted24`}
                                                        maxLength="6" onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)} onKeyUp={() => {
                                                            calculateTotals();
                                                            validateFieldPair(index, 'admitted24', 'cummulativeIntake24', (admitted, cummulativeIntake24) => admitted > cummulativeIntake24, clgCourseIntakeformik);

                                                        }} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].admitted24`} className='text-error' component='div' />

                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].sanctionedIntakeCompetentAuth23`}
                                                        maxLength="5" onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)}
                                                        onKeyUp={() => calculateTotals()} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].sanctionedIntakeCompetentAuth23`} className='text-error' component='div' />
                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].noOfSectionsCompetAuth23`}
                                                        maxLength="5" onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)}
                                                        onKeyUp={() => calculateTotals()} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].noOfSectionsCompetAuth23`} className='text-error' component='div' />

                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].approved23`}
                                                        maxLength="5" value={data?.approved_23}
                                                        onKeyUp={() => { calculateCumulativeIntake(index, '23'); calculateTotals() }} /></td>


                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].lateral23`}
                                                        maxLength="5" onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)}
                                                        onKeyUp={() => { calculateCumulativeIntake(index, '23'); calculateTotals() }} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].lateral23`} className='text-error' component='div' />


                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].ews23`}
                                                        maxLength="5" onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)}
                                                        style={{ width: "5rem" }}
                                                        onKeyUp={() => { calculateCumulativeIntake(index, '23'); calculateTotals() }} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].ews23`} className='text-error' component='div' />

                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].pioIntake23`}
                                                        maxLength="5" onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)}
                                                        onKeyUp={() => { calculateCumulativeIntake(index, '23'); calculateTotals() }} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].pioIntake23`} className='text-error' component='div' />


                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].cummulativeIntake23`}
                                                        maxLength="5" disabled="true"
                                                        onKeyUp={() => calculateTotals()} /></td>



                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].admitted23`}
                                                        maxLength="6" onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)}
                                                        // onKeyUp={() => { calculateTotals(); validateAdmittedValue(index); }} />
                                                        onKeyUp={() => {
                                                            calculateTotals();
                                                            validateFieldPair(index, 'admitted23', 'cummulativeIntake23', (admitted, cummulativeIntake23) => admitted > cummulativeIntake23, clgCourseIntakeformik);
                                                        }} />


                                                        <ErrorMessage name={`clgCourseIntake[${index}].admitted23`} className='text-error' component='div' />

                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].sanctionedIntakeCompetentAuth22`}
                                                        maxLength="5" onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)} onKeyUp={() => calculateTotals()} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].sanctionedIntakeCompetentAuth22`} className='text-error' component='div' />


                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].noOfSectionsCompetAuth22`}
                                                        maxLength="5" onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)} onKeyUp={() => calculateTotals()} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].noOfSectionsCompetAuth22`} className='text-error' component='div' />

                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].approved22`}
                                                        maxLength="5" onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)}
                                                        onKeyUp={() => { calculateCumulativeIntake(index, '22'); calculateTotals() }} />

                                                        <ErrorMessage name={`clgCourseIntake[${index}].approved22`} className='text-error' component='div' />

                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].lateral22`}
                                                        maxLength="5" onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)}
                                                        onKeyUp={() => { calculateCumulativeIntake(index, '22'); calculateTotals() }} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].lateral22`} className='text-error' component='div' />


                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].ews22`}
                                                        maxLength="5" onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)} style={{ width: "5rem" }}
                                                        onKeyUp={() => { calculateCumulativeIntake(index, '22'); calculateTotals() }} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].ews22`} className='text-error' component='div' />

                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].pioIntake22`}
                                                        maxLength="5" onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)}
                                                        onKeyUp={() => { calculateCumulativeIntake(index, '22'); calculateTotals() }} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].pioIntake22`} className='text-error' component='div' />

                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].cummulativeIntake22`}
                                                        maxLength="5" disabled="true" onKeyUp={() => calculateTotals()} /></td>


                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].admitted22`}
                                                        maxLength="6" onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)} onKeyUp={() => {
                                                            calculateTotals();
                                                            validateFieldPair(index, 'admitted22', 'cummulativeIntake22', (admitted, cummulativeIntake22) => admitted > cummulativeIntake22, clgCourseIntakeformik);

                                                        }} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].admitted22`} className='text-error' component='div' />


                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].sanctionedIntakeCompetentAuth21`}
                                                        maxLength="5" onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)} onKeyUp={() => calculateTotals()} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].sanctionedIntakeCompetentAuth21`} className='text-error' component='div' />

                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].noOfSectionsCompetAuth21`}
                                                        maxLength="5" onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)} onKeyUp={() => calculateTotals()} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].noOfSectionsCompetAuth21`} className='text-error' component='div' />

                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].approved21`}
                                                        maxLength="5" onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)}
                                                        onKeyUp={() => { calculateCumulativeIntake(index, '21'); calculateTotals() }} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].approved21`} className='text-error' component='div' />
                                                    </td>


                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].lateral21`}
                                                        maxLength="5" onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)}
                                                        onKeyUp={() => { calculateCumulativeIntake(index, '21'); calculateTotals() }} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].lateral21`} className='text-error' component='div' />

                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].ews21`} style={{ width: "5rem" }}
                                                        maxLength="5" onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)}
                                                        onKeyUp={() => { calculateCumulativeIntake(index, '21'); calculateTotals() }} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].ews21`} className='text-error' component='div' />

                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].pioIntake21`}
                                                        maxLength="5" onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)}
                                                        onKeyUp={() => { calculateCumulativeIntake(index, '21'); calculateTotals() }} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].pioIntake21`} className='text-error' component='div' />

                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].cummulativeIntake21`}
                                                        maxLength="5" disabled="true" onKeyUp={() => calculateTotals()} />

                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].admitted21`}
                                                        maxLength="6" onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)} onKeyUp={() => {
                                                            calculateTotals();
                                                            validateFieldPair(index, 'admitted21', 'cummulativeIntake21', (admitted, cummulativeIntake21) => admitted > cummulativeIntake21, clgCourseIntakeformik);

                                                        }} />

                                                        <ErrorMessage name={`clgCourseIntake[${index}].admitted21`} className='text-error' component='div' />

                                                    </td>


                                                </tr>
                                            ))}

                                            <tr style={{ backgroundColor: "#E8E3D1", fontSize: "25px", fontweight: "20px" }}>
                                                <td colSpan="4">Total</td>
                                                <td>{getDisplayValue(clgCourseIntakeformik?.values?.tot_sanctioned_intake_competent_auth_24, showTotCourseIntakedata?.tot_sanctioned_intake_competent_auth_24)}</td>
                                                <td>{getDisplayValue(clgCourseIntakeformik?.values?.tot_no_of_sections_compet_auth_24, showTotCourseIntakedata?.tot_no_of_sections_compet_auth_24)}</td>
                                                <td>{getDisplayValue(clgCourseIntakeformik?.values?.tot_approved_24, showTotCourseIntakedata?.tot_approved_24)}</td>
                                                <td>{getDisplayValue(clgCourseIntakeformik?.values?.tot_lateral_24, showTotCourseIntakedata?.tot_lateral_24)}</td>
                                                <td>{getDisplayValue(clgCourseIntakeformik?.values?.tot_ews_24, showTotCourseIntakedata?.tot_ews_24)}</td>
                                                <td>{getDisplayValue(clgCourseIntakeformik?.values?.tot_pio_intake_24, showTotCourseIntakedata?.tot_pio_intake_24)}</td>
                                                <td>{getDisplayValue(clgCourseIntakeformik?.values?.tot_cummulative_intake_24, showTotCourseIntakedata?.tot_cummulative_intake_24)}</td>
                                                <td>{getDisplayValue(clgCourseIntakeformik?.values?.tot_addmited_24, showTotCourseIntakedata?.tot_addmited_24)}</td>
                                                <td>{getDisplayValue(clgCourseIntakeformik?.values?.tot_sanctioned_intake_competent_auth_23, showTotCourseIntakedata?.tot_sanctioned_intake_competent_auth_23)}</td>
                                                <td>{getDisplayValue(clgCourseIntakeformik?.values?.tot_no_of_sections_compet_auth_23, showTotCourseIntakedata?.tot_no_of_sections_compet_auth_23)}</td>
                                                <td>{getDisplayValue(clgCourseIntakeformik?.values?.tot_approved_23, showTotCourseIntakedata?.tot_approved_23)}</td>
                                                <td>{getDisplayValue(clgCourseIntakeformik?.values?.tot_lateral_23, showTotCourseIntakedata?.tot_lateral_23)}</td>
                                                <td>{getDisplayValue(clgCourseIntakeformik?.values?.tot_ews_23, showTotCourseIntakedata?.tot_ews_23)}</td>
                                                <td>{getDisplayValue(clgCourseIntakeformik?.values?.tot_pio_intake_23, showTotCourseIntakedata?.tot_pio_intake_23)}</td>
                                                <td>{getDisplayValue(clgCourseIntakeformik?.values?.tot_cummulative_intake_23, showTotCourseIntakedata?.tot_cummulative_intake_23)}</td>
                                                <td>{getDisplayValue(clgCourseIntakeformik?.values?.tot_addmited_23, showTotCourseIntakedata?.tot_addmited_23)}</td>

                                                <td>{getDisplayValue(clgCourseIntakeformik?.values?.tot_sanctioned_intake_competent_auth_22, showTotCourseIntakedata?.tot_sanctioned_intake_competent_auth_22)}</td>
                                                <td>{getDisplayValue(clgCourseIntakeformik?.values?.tot_no_of_sections_compet_auth_22, showTotCourseIntakedata?.tot_no_of_sections_compet_auth_22)}</td>
                                                <td>{getDisplayValue(clgCourseIntakeformik?.values?.tot_approved_22, showTotCourseIntakedata?.tot_approved_22)}</td>
                                                <td>{getDisplayValue(clgCourseIntakeformik?.values?.tot_lateral_22, showTotCourseIntakedata?.tot_lateral_22)}</td>
                                                <td>{getDisplayValue(clgCourseIntakeformik?.values?.tot_ews_22, showTotCourseIntakedata?.tot_ews_22)}</td>
                                                <td>{getDisplayValue(clgCourseIntakeformik?.values?.tot_pio_intake_22, showTotCourseIntakedata?.tot_pio_intake_22)}</td>
                                                <td>{getDisplayValue(clgCourseIntakeformik?.values?.tot_cummulative_intake_22, showTotCourseIntakedata?.tot_cummulative_intake_22)}</td>
                                                <td>{getDisplayValue(clgCourseIntakeformik?.values?.tot_addmited_22, showTotCourseIntakedata?.tot_addmited_22)}</td>

                                                <td>{getDisplayValue(clgCourseIntakeformik?.values?.tot_sanctioned_intake_competent_auth_21, showTotCourseIntakedata?.tot_sanctioned_intake_competent_auth_21)}</td>
                                                <td>{getDisplayValue(clgCourseIntakeformik?.values?.tot_no_of_sections_compet_auth_21, showTotCourseIntakedata?.tot_no_of_sections_compet_auth_21)}</td>
                                                <td>{getDisplayValue(clgCourseIntakeformik?.values?.tot_approved_21, showTotCourseIntakedata?.tot_approved_21)}</td>
                                                <td>{getDisplayValue(clgCourseIntakeformik?.values?.tot_lateral_21, showTotCourseIntakedata?.tot_lateral_21)}</td>
                                                <td>{getDisplayValue(clgCourseIntakeformik?.values?.tot_ews_21, showTotCourseIntakedata?.tot_ews_21)}</td>
                                                <td>{getDisplayValue(clgCourseIntakeformik?.values?.tot_pio_intake_21, showTotCourseIntakedata?.tot_pio_intake_21)}</td>
                                                <td>{getDisplayValue(clgCourseIntakeformik?.values?.tot_cummulative_intake_21, showTotCourseIntakedata?.tot_cummulative_intake_21)}</td>
                                                <td>{getDisplayValue(clgCourseIntakeformik?.values?.tot_addmited_21, showTotCourseIntakedata?.tot_addmited_21)}</td>


                                            </tr>



                                        </tbody>
                                    </table>


                                </div>
                                <bie.Row className="px-3 pt-4">
                                    <div className='d-flex flex-row justify-content-end pb-1'>
                                        <button type="submit" className="btn rounded-0 btn-success btn-sm">Save</button>
                                    </div>
                                </bie.Row>
                            </> : null}


                            {sowCourseIntakedata?.length > 0 && (<>
                                <div className="table-responsive">
                                    <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                        <thead>
                                            <tr>
                                                <th rowSpan={3} >Slno</th>
                                                <th rowSpan={3}>Course/Programme</th>
                                                <th rowSpan={3} >Branch/Combination</th>
                                                <th rowSpan={3}>Year of<br />Starting Course</th>
                                                <th colSpan={32}>Details of Intake year wise</th>
                                            </tr>
                                            <tr>
                                                <th colSpan={8}>2024-25</th>
                                                <th colSpan={8}>2023-24</th>
                                                <th colSpan={8}>2022-23</th>
                                                <th colSpan={8}>2021-22</th>

                                            </tr>
                                            <tr>
                                                <th rowSpan={1}>Sanctioned by Competent Authority (AICTE/APSCHE/BCI/PCI)</th>
                                                <th colSpan={1}>Approved Number of Sections</th>
                                                <th colSpan={1} >Approved Intake by University</th>
                                                <th colSpan={1} >Lateral Entries</th>
                                                <th colSpan={1} >EWS</th>
                                                <th colSpan={1} >NRI/PIO/Foreign</th>
                                                <th colSpan={1} >Cumulative Intake</th>
                                                <th colSpan={1} >Admitted</th>

                                                <th rowSpan={1} >Sanctioned by Competent Authority (AICTE/APSCHE/BCI/PCI)</th>
                                                <th colSpan={1} >Approved Number of Sections</th>
                                                <th colSpan={1} >Approved Intake by University</th>
                                                <th colSpan={1} >Lateral Entries</th>
                                                <th colSpan={1} >EWS</th>
                                                <th colSpan={1} >NRI/PIO/Foreign</th>
                                                <th colSpan={1} >Cumulative Intake</th>
                                                <th colSpan={1} >Admitted</th>

                                                <th rowSpan={1} >Sanctioned by Competent Authority (AICTE/APSCHE/BCI/PCI)</th>
                                                <th colSpan={1} >Approved Number of Sections</th>
                                                <th colSpan={1} >Approved Intake by University</th>
                                                <th colSpan={1} >Lateral Entries</th>
                                                <th colSpan={1} >EWS</th>
                                                <th colSpan={1} >NRI/PIO/Foreign</th>
                                                <th colSpan={1} >Cumulative Intake</th>
                                                <th colSpan={1} >Admitted</th>

                                                <th rowSpan={1} >Sanctioned by Competent Authority (AICTE/APSCHE/BCI/PCI)</th>
                                                <th colSpan={1} >Approved Number of Sections</th>
                                                <th colSpan={1} >Approved Intake by University</th>
                                                <th colSpan={1} >Lateral Entries</th>
                                                <th colSpan={1} >EWS</th>
                                                <th colSpan={1} >NRI/PIO/Foreign</th>
                                                <th colSpan={1} >Cumulative Intake</th>
                                                <th colSpan={1} >Admitted</th>
                                            </tr>

                                        </thead>
                                        <tbody style={{ textAlign: "center" }}>
                                            {sowCourseIntakedata && sowCourseIntakedata?.map((data1, i) => (<>
                                                <tr>
                                                    <td>{i + 1}</td>
                                                    <td >
                                                        {`${data1?.course_cat_name}(${data1?.medium})/${data1?.reg_self}/${data1?.course_affl_type}`}
                                                    </td>

                                                    <td > {data1?.course_name ?? '-'} </td>
                                                    <td>{data1?.course_start_date ?? '-'}</td>

                                                    <td>{data1?.sanctioned_intake_competent_auth_24 ?? '-'}</td>
                                                    <td>{data1?.no_of_sections_compet_auth_24 ?? '-'} </td>
                                                    <td>{data1?.approved_24 ?? '-'}</td>
                                                    <td>{data1?.lateral_24 ?? '-'}</td>
                                                    <td>{data1?.ews_24 ?? '-'}</td>
                                                    <td>{data1?.pio_intake_24 ?? '-'} </td>
                                                    <td>{data1?.cummulative_intake_24 ?? '-'} </td>
                                                    <td>{data1?.addmited_24 ?? '-'}</td>

                                                    <td>{data1?.sanctioned_intake_competent_auth_23 ?? '-'}</td>
                                                    <td>{data1?.no_of_sections_compet_auth_23 ?? '-'} </td>
                                                    <td>{data1?.approved_23 ?? '-'}</td>
                                                    <td>{data1?.lateral_23 ?? '-'}</td>
                                                    <td>{data1?.ews_23 ?? '-'}</td>
                                                    <td>{data1?.pio_intake_23 ?? '-'} </td>
                                                    <td>{data1?.cummulative_intake_23 ?? '-'} </td>
                                                    <td>{data1?.addmited_23 ?? '-'}</td>

                                                    <td>{data1?.sanctioned_intake_competent_auth_22 ?? '-'}</td>
                                                    <td>{data1?.no_of_sections_compet_auth_22 ?? '-'} </td>
                                                    <td>{data1?.approved_22 ?? '-'}</td>
                                                    <td>{data1?.lateral_22 ?? '-'}</td>
                                                    <td>{data1?.ews_22 ?? '-'}</td>
                                                    <td>{data1?.pio_intake_22 ?? '-'} </td>
                                                    <td>{data1?.cummulative_intake_22 ?? '-'} </td>
                                                    <td>{data1?.addmited_22 ?? '-'}</td>

                                                    <td>{data1?.sanctioned_intake_competent_auth_21 ?? '-'}</td>
                                                    <td>{data1?.no_of_sections_compet_auth_21 ?? '-'} </td>
                                                    <td>{data1?.approved_21 ?? '-'}</td>
                                                    <td>{data1?.lateral_21 ?? '-'}</td>
                                                    <td>{data1?.ews_21 ?? '-'}</td>
                                                    <td>{data1?.pio_intake_21 ?? '-'} </td>
                                                    <td>{data1?.cummulative_intake_21 ?? '-'} </td>
                                                    <td>{data1?.addmited_21 ?? '-'}</td>



                                                </tr>
                                            </>))}
                                            <tr></tr>
                                        </tbody>
                                    </table>
                                </div>
                            </>)}


                        </Form >
                    </FormikProvider >
                </bie.Container>
            </bie.Container>
        </>
    )
}
